import { axiosClient } from "../axios";

export function exportQuizzes() {
  return axiosClient.get("export/quizzes/xlsx");
}
